export const toNumber = (input: string | number | null): number => {
  if (typeof input === 'number') return input;

  return input ? Number(input.replace(/,/g, '')) : 0;
};

export const isNonEmptyNumber = (input?: string | number | null): boolean => {
  if (input == null || input === '') return false;

  return true;
};
